import { SERVER_URI } from '../Constant/server';
import { apiPost, } from '../utils/axios';

const ADD_RECIPE = SERVER_URI + '/recipe-master';

const BIND_RECIPE = SERVER_URI + '/get-recipe-master';
const BIND_PRODUCT_TYPE_LOCATION_BY = SERVER_URI + '/get-product-type-by-location';


export default {

  Create_Add_Recipe: async function (paylaod) {
    return apiPost(ADD_RECIPE, paylaod)
  },
  getRecipe: async function (paylaod) {
    return apiPost(BIND_RECIPE, paylaod)
  },
  getProductTypeLocationBy: async function (paylaod) {
    return apiPost(BIND_PRODUCT_TYPE_LOCATION_BY, paylaod)
  }
};